"use client";
'use strict';

var React = require('react');

function useUnmountEffect(fn, deps = []) {
    return React.useEffect(() => () => fn(), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
}

exports.useUnmountEffect = useUnmountEffect;
//# sourceMappingURL=useUnmountEffect.js.map
